import React, { useState, useEffect, useMemo } from "react";
import { API } from "../../API";
import AdminWrapper from "./AdminWrapper"
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar";
import ReactTable from "react-table-6";
import moment from "moment";
import { getTeacherProfileName } from "../../Helper";
import FormDropdown from "../../Components/FormField/FormDropdown";
import Modal from "../../Components/Modal/Modal";
import Pagination from "@mui/material/Pagination";

function UserLogs() {
  const [allUsers, setAllUsers] = useState([]);
  const [allInstUsers, setAllInstUsers] = useState([]);
  const [allTypeNames, setAllTypeNames] = useState([]);
  const [allActorEmails, setAllActorEmails] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchEmail, setSearchEmail] = useState("");
  const [searchAction, setSearchAction] = useState("");
  const [selectedLogDetails, setSelectedLogDetails] = useState(undefined);

  useEffect(() => {
    setLoading(true);
    getUsers();
    getAllTypeNameAndActorEmail();
  }, []);

  useEffect(() => {
    if (
      allUsers.length > 0 &&
      allInstUsers.length > 0
    ) {
      getLogData();
    }
  }, [allUsers, allInstUsers])

  const getUsers = () => {
    API.allTeachersForAllocate()
      .then(function (result) {
        setAllUsers(result.data);
      })
      .catch(function (err) {
        console.log(err);
      });

    API.allInstUsersForAllocate()
      .then((result) => {
        setAllInstUsers(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getAllTypeNameAndActorEmail = () => {
    API.getAllTypeNameAndActorEmail()
      .then((res) => {
        setAllActorEmails(res.data.emails)
        setAllTypeNames(res.data.types)
    })
      .catch((err) => {
      console.log(err);
    });
  }

  const getLogData = (email, type, page, limit) => {
    setLoading(true);
    API.getUserLog(email, type, page, limit)
      .then(res => {
        // console.log(res.data)
        const totalPage = res.data.paginate.total_page
        if (page > totalPage) {
          setCurrentPage(totalPage)
          getLogData(email, type, totalPage, limit)
        } else {
          let logs = res.data.logs;
          let data = []
          logs.forEach(log => {
            let name = ""
            if (allUsers.find(t => t._id === log.actor_id)) {
              const user = allUsers.find(u => u._id === log.actor_id)
              // console.log(user)
              if (user.first_name && user.last_name) {
                name = getTeacherProfileName(user)
              }

              let role = user.role
              if (log?.is_admin) {
                role = "Admin";
              }

              data.push({
                ...log,
                name: name,
                role
              })
            } else {
              const instUser = allInstUsers.find(user => user._id === log.actor_id)
              // console.log(instUser)
              let role = ""
              if (instUser?.personnel_first_name && instUser?.personnel_last_name) {
                role = "personnel";
                name = instUser.personnel_first_name + " " + instUser.personnel_last_name[0].toUpperCase()
              }
              if (instUser?.first_name && instUser?.last_name) {
                role = "customer";
                name = instUser.first_name + " " + instUser.last_name[0].toUpperCase()
              }

              if (log?.is_admin) {
                role = "Admin";
              }

              data.push({
                ...log,
                name: name,
                role: role
              })
            }
          })
          setData(data)
          setPageCount(totalPage)
          setLoading(false);
        }
      })
      .catch(error => {
        console.log(error)
        setLoading(false);
      })
  }

  const getLogDetail = (logId) => {
    API.getLogDetail(logId).then(res => {
      // console.log(res.data)
      setSelectedLogDetails(res.data.request_body)
    })
      .catch(error => {
      console.log(error)
    })
  }

  const columns = useMemo(() => [
    {
      Header: "Name",
      accessor: "name",
      show: true,
      width: 150,
      Cell: (props) => <BasicCell content={props.original.name} />
    },
    {
      Header: "Role",
      accessor: "role",
      show: true,
      width: 100,
      Cell: (props) => <BasicCell content={props.original.role} />
    },
    {
      Header: "Email",
      accessor: "actor_email",
      show: true,
      width: 280,
      Cell: (props) => <BasicCell content={props.original.actor_email} />,
      filterable: true,
      Filter: () => (
        <FormDropdown
          value={searchEmail}
          onChange={(e) => {
            const email = e.target.value.trim()
            setSearchEmail(email)
            setCurrentPage(1)
            getLogData(email, searchAction, 1, pageSize);
          }}
        >
          <option value="">
            Select Email
          </option>
          {allActorEmails && allActorEmails.map((email) =>
            <option value={email}>{email}</option>)}
        </FormDropdown>
      )
    },
    {
      Header: "Action",
      accessor: "type",
      show: true,
      width: 220,
      Cell: (props) => <BasicCell content={props.original.type} />,
      filterable: true,
      Filter: () => (
        <FormDropdown
          value={searchAction}
          onChange={(e) => {
            const action = e.target.value
            setSearchAction(action)
            setCurrentPage(1)
            getLogData(searchEmail, action, 1, pageSize);
          }}
        >
          <option value="">
            Select Action Type
          </option>
          {allTypeNames && allTypeNames.map((type) =>
            <option value={type}>{type}</option>)}
        </FormDropdown>
      )
    },
    {
      Header: "URL",
      accessor: "request_url",
      show: true,
      width: 400,
      Cell: (props) => <BasicCell content={props.original.request_url} />
    },
    {
      Header: "Time",
      accessor: "createdAt",
      show: true,
      width: 180,
      Cell: (props) => <BasicCell content={moment(props.original.createdAt).tz("Australia/Melbourne").format('DD-MM-YYYY, h:mm a')} />
    },
    {
      Header: "Details",
      accessor: "",
      show: true,
      width: 120,
      Cell: (props) =>
        <button
          className="btn btn-primary"
          id={props.original._id}
          onClick={() => getLogDetail(props.original._id)}
        >
          View Details
      </button>
    }
  ]);

  const BasicCell = ({ content }) => (
    <div className="basic-cell-container">
      <div className="basic-cell-child-element">{content}</div>
    </div>
  );

  return (
    <AdminWrapper>
      <SwitchMenuBar isViewAsTeacher />
      <div className="all-availability-table-container">
        <h1 className="text-3xl font-bold text-center">User Logs</h1>
        <ReactTable
          className="-striped -highlight"
          showPagination={false}
          data={data}
          sortable={false}
          loading={loading}
          pageSize={pageSize}
          columns={columns}
        />
        <div className="d-flex justify-content-center">
          <Pagination
            className="mt-3 mr-5"
            page={currentPage}
            count={pageCount}
            onChange={(e, value) => {
              getLogData(searchEmail, searchAction, value, pageSize);
              setCurrentPage(value)
            }}
          />
          <FormDropdown
            value={pageSize}
            onChange={(e) => {
              getLogData(searchEmail, searchAction, currentPage, e.target.value);
              setPageSize(e.target.value)
            }}
          >
            <option value={10}>10 rows</option>
            <option value={20}>20 rows</option>
            <option value={50}>50 rows</option>
            <option value={100}>100 rows</option>
          </FormDropdown>
        </div>
      </div>
      {selectedLogDetails && <Modal
        className="confirm-delete"
        header="Log Details"
        show={true}
        onClose={() => setSelectedLogDetails(undefined)}
      >
        <div className="row m-0">
          <pre>{JSON.stringify(selectedLogDetails, null, 2)}</pre>
        </div>
      </Modal>}
    </AdminWrapper>
  );
}

export default UserLogs;